<template>
  <v-dialog v-model="open" persistent :width="width">
    <v-card>
      <v-card-title>
        <h4>
          <slot name="title" />
        </h4>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <slot />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="close">Cancel</v-btn>
        <div style="margin-left: 15px">
          <slot name="actions" />
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ActionModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
  computed: {
    open() {
      return this.isOpen;
    },
    width() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "100%";
        case "sm":
          return "80%";
        case "md":
          return "50%";
        case "lg":
          return "40%";
        case "xl":
          return "30%";
        default:
          return "100%";
      }
    },
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
};
</script>
